<template lang="pug">
v-container
  v-card
    v-card-text
      v-layout(wrap)
        v-flex(xs12 sm6)
          v-text-field(label="QR-Code" v-model="qrcode")
          v-checkbox(label="Mit Text" v-model="withText")
          v-textarea(label="Text" v-model="text" v-if="withText")

        v-flex(xs12 sm6)
          hvd-qrcode(:input="qrcode" :text="qrText")

</template>


<script>
export default {
  props: ['extra'],
  data() {
    return {
      qrcode: "",
      withText: true,
      text: "",
    }
  },
  computed: {
    qrText() {
      return (this.withText ? this.text || this.qrcode.replace(/^https?:\/\//, '') : null)
    }
  },
  methods: {
    downloadQrcode() {
      qrCodeEl.download({ name: `HVD-QR-${this.qrText}`, skipDownload: false })
    },
  },
}
</script>
